import React, { useImperativeHandle, useRef, forwardRef } from 'react';
import { Row, Col } from "antd";
import { Button, FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import RazorPayButton from "../../../../../../helpers/RazorPayButton"
import { SelectedIcon, UnSelectedIcon } from "../../../../../Shared/components/Icons/selectedIcon";
import { idNamingConversion } from '../../../../../../helpers/utilities';


export const Plans = forwardRef((props, ref) => {
    const razorPayRef = useRef('');
    const planRef = useRef('');
    const { classes, clsx, subscriptionCheck, businessDetails, subscriptionOrder, handleError,
        currencyFormatInt, loader, details, capitalizeFirstLetter, handleChangePlan, frequency, handleSubscription, createLoader, subscriptionDetails, displayData } = props;


    useImperativeHandle(ref, () => ({
        payNow() {
            razorPayRef?.current?.payNow();
        },
        scrollView() {
            planRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' })
        }
    }));


    return (
        <div ref={planRef} className={clsx(classes.billingDetails, classes.billingPlanDetails, { [classes.loadingA]: subscriptionCheck })}>
            <div className={clsx(classes.planHeader, classes.marginBillingTop)}>
                <h6 className={clsx(classes.typographyHeader, classes.bold)}>Plan Details</h6>
                <FormControl
                    className={clsx(classes.dropDownPointer, classes.customRadioButton)}
                    variant={'standard'}
                    id={idNamingConversion('Plan Details', 'billingsPlans', 'Radio')}>
                    <RadioGroup
                        row
                        defaultValue={1}
                        aria-labelledby="demo-customized-radios"
                        name="productFilter"
                        value={frequency}
                        onChange={(e) => handleChangePlan(e.target.value)}>
                        <FormControlLabel value={'MONTHLY'} control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="Monthly" />
                        <FormControlLabel value={'YEARLY'} control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="Yearly" />
                    </RadioGroup>
                </FormControl>
            </div>
            <Row gutter={100}>
                {
                    loader ? <div className={classes.textAlignCenter} style={{ width: "100%" }}>
                        <div className={classes.loadMoreCircle}></div>
                    </div> : details.length > 0 ? details?.map((data, i) => (
                        <Col key={i} xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <div className={clsx({ [classes.planFirstCols]: subscriptionDetails?.planId === data.id }, classes.textAlignCenter, classes.planCols)}>
                                <span to="#" className={clsx(classes.planColsButton, classes.planButton, classes.bold)}>{data?.planName}</span>
                                <div className={classes.planContain}>
                                    {/* <FormControlLabel
                                        classes={{
                                            label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                        }}
                                        control={<Switch size='small'
                                            className={clsx(classes.customSwitch)}
                                            onChange={(e) => handleChangePlan(data, i)}
                                        />}
                                        label={false}
                                        labelPlacement="top"
                                        className={clsx(classes.marginLeft0, classes.margin40t)}
                                    /> */}
                                    {/* <p className={clsx(classes.billingText, classes.margin40t)}>{data?.description}</p> */}
                                    <p className={clsx(classes.billingAmount, classes.margin40b, classes.margin40t)}><span className={clsx(classes.billingAmount, classes.bold)}>{`₹ ${currencyFormatInt(data?.planAmount)}`}<span>{capitalizeFirstLetter(data?.frequency)}</span></span></p>
                                </div>
                                <div className={clsx(classes.planList, classes.textAlignCenter, subscriptionDetails?.planId)}>
                                    {
                                        subscriptionDetails?.planId === data.id ? <p className={classes.billingText} style={{ color: "#000" }}>Current Plan</p> :
                                            <p className={classes.billingText} style={{ color: "#000" }}>
                                                {
                                                    subscriptionOrder?.payment?.id && subscriptionOrder?.order?.planId === data.id ? <>
                                                        {
                                                            subscriptionOrder?.order?.subscriptionOrderStatus === 'ONGOING' &&
                                                                subscriptionOrder?.payment?.subscriptionPaymentStatus === 'CREATED' ?
                                                                <RazorPayButton ref={razorPayRef} text={'Pay Now'} handleError={(data) => handleError(data)}
                                                                    businessDetails={businessDetails}
                                                                    orderId={subscriptionOrder?.order?.vendorReferenceId}
                                                                    paymentId={subscriptionOrder?.payment?.id}
                                                                    amount={data?.planAmount}
                                                                    name={data.planName}
                                                                    description={data?.description} /> : <Button
                                                                        id={idNamingConversion('Pay Now_' + data.id, 'billingsPlans', 'Button')}
                                                                        className={clsx(classes.modalBtn, classes.disabled)}>Pay Now</Button>
                                                        }
                                                    </>
                                                        : <>
                                                            {
                                                                displayData?.subscriptionPaymentId &&
                                                                    displayData.planId === data.id ? <RazorPayButton handleError={(data) => handleError(data)} ref={razorPayRef} text={'Pay Now'}
                                                                        businessDetails={businessDetails}
                                                                        paymentId={displayData?.subscriptionPaymentId}
                                                                        amount={data?.planAmount}
                                                                        orderId={displayData?.orderId}
                                                                        name={data.planName}
                                                                        description={data?.description} /> : <>
                                                                    {
                                                                        subscriptionOrder?.payment?.id ? <Button
                                                                            id={idNamingConversion('Upgrade_' + data.id, 'billingsPlans', 'Button')}
                                                                            className={clsx(classes.modalBtn, classes.disabled)}>Upgrade</Button> : <Button
                                                                                id={idNamingConversion('Upgrade_' + data.id, 'billingsPlans', 'Button')}
                                                                                onClick={() => handleSubscription(data)}
                                                                                className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}>Upgrade</Button>
                                                                    }
                                                                </>
                                                            }
                                                        </>
                                                }
                                            </p>
                                    }
                                    {
                                        data?.description ? <ul>
                                            <li>{data?.description}</li>
                                        </ul> : ''
                                    }
                                </div>
                            </div>
                        </Col>
                    )) : <div className={classes.textAlignCenter} style={{ width: "100%" }}>
                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>There are no plans available</p>
                    </div>
                }
            </Row>
        </div>
    )
});